import { addDays, parseISO } from 'date-fns';
import {
  TENANCY_END_DATE_TYPE,
  TENANCY_LENGTH_TYPE,
  TENANCY_START_DATE_TYPE,
} from '~graphql-types';

export const onTenancyOptionsChange = ({ tenancyOption, selectedStartDate, selectedEndDate }) => {
  if (!tenancyOption) return [selectedStartDate, selectedEndDate];
  const { startDateType, endDateType, tenancyLength, tenancyLengthType } = tenancyOption;
  const tenancyOptionStartDate = parseISO(tenancyOption.startDate);
  const tenancyOptionEndDate = parseISO(tenancyOption.endDate);
  const isEQStartDateType = startDateType === TENANCY_START_DATE_TYPE.EQ;
  const isEQEndDateType = endDateType === TENANCY_END_DATE_TYPE.EQ;
  const isEQTenancyLengthType = tenancyLengthType === TENANCY_LENGTH_TYPE.EQ;

  if (isEQTenancyLengthType) {
    return [selectedStartDate, addDays(selectedStartDate, tenancyLength)];
  }

  if (isEQStartDateType) {
    return [tenancyOptionStartDate, selectedEndDate];
  }

  if (isEQEndDateType) {
    return [selectedStartDate, tenancyOptionEndDate];
  }

  return [selectedStartDate, selectedEndDate];
};
